export enum SocialProviders {
  GOOGLE = 'google',
  FACEBOOK = 'facebook',
  APPLE = 'apple'
}

export interface SocialAuthState {
  loaded: boolean;
  loginStatus: SocialAuthStatus;
}

export interface SocialAuthStatus {
  status: SocialAuthStatusEnum;
  // tslint:disable-next-line:no-any
  payload?: any;
}

export enum SocialAuthStatusEnum {
  Void,
  Finished,
  Started,
  Error,
  ErrorEmail
}
